module.exports = __webpack_public_path__ + "img/warning.96cea49e.svg";